// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    $(document).ready(function () {
        // .. ... ...
        // .. When using # tag in the url, it can result in multible active menu links. Therefore we have to remove the false active 
        // .. ... ...
        var activeLinks = $('header.big-menu .sub-menu li.active');
        if ((activeLinks.length) > 1) {
            if (location.hash) {
                activeLinks.each(function () {
                    var arr = $(this).find("a").attr('href').split('#');
                    if (!arr[1] || location.hash != "#"+arr[1] ) {
                        $(this).removeClass('active');
                    }
                    
                });
            }
            else {
                activeLinks.each(function () {
                    var arr = $(this).find("a").attr('href').split('#');
                    if (arr[1]) {
                        $(this).removeClass('active');
                    }

                });
            }
        }
        
        var pathname = window.location.pathname;
        var url = window.location.href;
        var httpsURL = window.location.protocol + '//' + window.location.hostname + ':443' + window.location.pathname;
        var httpURL = window.location.protocol + '//' + window.location.hostname + ':80' + window.location.pathname;

        // Active elements are set to static colour red, change to add active class to button
        $("header").find('a[href="' + pathname + '"], a[href="' + url + '"], a[href="' + httpsURL + '"], a[href="' + httpURL + '"]').parent('.button').addClass('active');
        
    });
})(window, document, jQuery);

